export default (clientHttp, apiVersion) => ({
  create(params) {
    return clientHttp.post(`${apiVersion}/business_contact_inquiries`, params)
  },
})
